__turbopack_context__.v({
  "arrow-pointing-right": "Link-module-scss-module__od1N5G__arrow-pointing-right",
  "icon": "Link-module-scss-module__od1N5G__icon",
  "link": "Link-module-scss-module__od1N5G__link",
});
